import React, { useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/free-solid-svg-icons';
import { IconEmptySquare } from '../../components/Icon';

const SELECTED_COLOR = '#2BB842';

type SelectRowRendererProps = {
    selected: boolean;
    onClick?: (rows: string[]) => void;
    row?: any;
};

const SelectRowRenderer = ({ selected, onClick, row }: SelectRowRendererProps): JSX.Element => {
    const addRemoveFromSelected = useCallback(
        (row: any): void => {
            if (onClick) {
                onClick([row]);
            }
        },
        [onClick],
    );

    return (
        <div
            className="component-select-row-renderer"
            onClick={(): void => addRemoveFromSelected(row)}
        >
            {selected ? (
                <FontAwesomeIcon
                    icon={faCheck}
                    color={SELECTED_COLOR}
                    size="lg"
                    style={{ strokeWidth: 30, stroke: SELECTED_COLOR }}
                />
            ) : (
                <IconEmptySquare />
            )}
        </div>
    );
};

export default SelectRowRenderer;
